//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : Pantalla principal de estadisticas de reclamos que son
// instalacion -> id_motivo = 19
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import Navbar from "../../../Navbar";
import Tabla_estados_inst from "./Tabla_estados_inst";
import Graf_estados_inst from "./Graf_estados_inst";
import Tabla_instaladores_inst from "./Tabla_instaladores_inst";
import Tabla_tanque from "./Tabla_tanque";
import Graf_tanques from "./Graf_tanques";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { logEventos } from "../../../../services/services";
function Estadisticas_instalacion() {
  const [selectedDate, setSelectedDate] = useState(
    dayjs().subtract(1, "month").startOf("month")
  );

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Area Tecnica",
      "Area Tecnica",
      "Panel de estadísticas de instalación",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={2}
        color="white"
        textAlign="center"
        marginTop={1}
      >
        <Typography
          sx={{
            typography: { xs: "h6", sm: "h5", md: "h4" }, // Tamaño de fuente responsive
          }}
        >
          Panel de estadísticas de instalación
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <DatePicker
            views={["year"]}
            // label="Año"
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  marginTop: 2,
                  width: { xs: "140px", sm: "180px", md: "200px" },
                  backgroundColor: "white", // Fondo blanco
                  "& .MuiInputBase-input": {
                    backgroundColor: "white", // Asegura que el input también sea blanco
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>
      <Grid container spacing={2} padding={2} justifyContent={"center"}>
        <Grid
          container
          spacing={2}
          padding={1}
          justifyContent={"left"}
          marginTop={1}
        >
          <Grid item xs={12} sm={12}>
            <Tabla_estados_inst selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Graf_estados_inst selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_instaladores_inst selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Tabla_tanque selectedDate={selectedDate} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Graf_tanques selectedDate={selectedDate} />
          </Grid>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
    </div>
  );
}

export default Estadisticas_instalacion;
